export default "__VITE_ASSET__Bl9Qu$rW__"